import React from 'react'

export default function UILoader() {
  return (
    <div id="show_loader"  class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  )
}
